// Einheitlicher, EINREIHIGER Seitenkopf (Ticket „Obere Leiste einreihig +
// auf allen Seiten einheitlich"). Entspricht dem faktischen Standardmuster,
// das 18 Routen bisher handkopiert hatten, erweitert um einen Inline-Slot
// nach dem Vorbild der bereits einreihigen Köpfe (Kalender, Stundenkonten):
//
//   [Titel]  [inline: Tabs/Nav/Switcher …]            [actions rechts]
//
// Die Zeile bricht bei Platznot kontrolliert um (flex-wrap) — „einreihig"
// heißt: EINE logische Leiste, kein gestapelter Titel-/Toolbar-Turm.
//
//   <PageHeader title="Mail" actions={…} />
//   <PageHeader title="Einstellungen" phoneMode="keep-row" inline={<Tabs/>} />
//
// phoneMode:
// - 'hidden' (Default): ganze Zeile am Phone aus — die Shell-Top-Leiste
//   trägt den Titel, Aktionen liegen in den MobileBottomSlots (Muster der
//   18 Standardköpfe).
// - 'keep-row': Titel UND Eyebrow verschwinden am Phone (Shell übernimmt
//   den Titel), inline/actions bleiben sichtbar (Muster Stundenkonten/
//   Aufgaben — deren Steuerelemente existieren mobil nur hier).

import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

interface PageHeaderProps {
  title: string
  /** Kompakter Kontext-Label über dem Titel (ersetzt die alte
   *  Breadcrumb-Zeile der Serif-Köpfe). */
  eyebrow?: string
  /** Inline-Slot in derselben Zeile: Tab-Pills, View-Switcher, Navigation. */
  inline?: ReactNode
  /** Rechtsbündige Aktionen (ml-auto). */
  actions?: ReactNode
  phoneMode?: 'hidden' | 'keep-row'
  className?: string
}

export function PageHeader({
  title,
  eyebrow,
  inline,
  actions,
  phoneMode = 'hidden',
  className,
}: PageHeaderProps) {
  return (
    <header
      className={cn(
        'flex flex-wrap items-center gap-x-3 gap-y-2 pb-3 border-b border-border-subtle',
        phoneMode === 'hidden' && 'phone:hidden',
        className,
      )}
    >
      <div className={cn('min-w-0', phoneMode === 'keep-row' && 'phone:hidden')}>
        {eyebrow && (
          <p className="text-2xs font-medium uppercase tracking-wider text-text-tertiary">
            {eyebrow}
          </p>
        )}
        <h1 className="text-lg font-medium tracking-tight text-text-primary leading-tight truncate">
          {title}
        </h1>
      </div>
      {inline}
      {/* max-w-full statt shrink-0: mit shrink-0 wäre die flex-base-size
          max-content und der Slot würde nie schmaler — das innere flex-wrap
          griffe nie, am Phone (keep-row) ragte der Kopf hinter die
          overflow-x-hidden-Kante (Review-Fund, /tasks bei 375px). */}
      {actions && (
        <div className="flex flex-wrap items-center gap-1.5 max-w-full ml-auto">{actions}</div>
      )}
    </header>
  )
}
